import { createUseStyles } from 'react-jss'

import background from '../../assets/images/delete_account.png'

export const useStyle = createUseStyles({
  modal: {
    marginTop: 8,
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top, center left 50px',
    backgroundImage: `url(${background})`,
    zIndex: 1,
    width: 520,
    height: 263
  },
  container: {},
  title: {
    marginTop: 312
  },
  description: {
    marginTop: 16,
    textAlign: 'center'
  },
  refundTitle: {
    marginTop: 40
  },
  refundPrice: {
    marginTop: 16
  },
  '@media screen and (max-height: 640px)': {
    container: {
      maxWidth: 480
    },
    modal: {
      backgroundSize: '70%',
      padding: '0 16px',
      width: 448,
      height: 263
    },
    title: {
      marginTop: 128
    }
  },
  '@media screen and (max-width: 480px)': {
    modal: {
      width: '90%'
    },
    title: {
      marginTop: 194
    }
  }
})
